/**
 * <s-sticky-buy> — Mobile buy bar. Slides in (sets `data-visible`) once the product
 * form's main add-to-cart button (`[data-main-buy]` in the same form) has scrolled
 * out of view, and hides again when it returns. While hidden the bar is `inert`
 * so it never takes focus.
 */
class SStickyBuy extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const target = this.closest('form')?.querySelector('[data-main-buy]');
    this.#setVisible(false);
    if (!target) return;
    this.#observer = new IntersectionObserver(
      ([entry]) => {
        // Show only after the main button has scrolled up past the viewport, not before reaching it.
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.#setVisible(scrolledPast);
      },
      { threshold: 0 },
    );
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', SStickyBuy);
